import { connect } from 'react-redux'
import get from 'lodash/get'
import PropTypes from 'prop-types'

import * as buttonActions from 'common/builder/actions/buttonActions'
import NextStepSelect from 'common/builder/components/builder/NextStepSelect'
import * as entitySelectors from 'common/builder/selectors/builder/entitySelectors'
import { getCurrentAccount } from 'common/core/selectors/appSelectors'

const ButtonNextStepSelectController = connect(
  (state, props) => {
    const { builderId, buttonId } = props
    const parentNode = entitySelectors.getParentNode(state, builderId, buttonId)
    const isPro = getCurrentAccount(state).isPro
    return {
      parentNodeId: get(parentNode, 'id', null),
      isPro,
    }
  },
  (dispatch, props) => ({
    onSelect: (nextStepType) => {
      const { builderId, buttonId, keepType } = props
      dispatch(buttonActions.selectButtonNextStep(builderId, buttonId, { nextStepType, keepType }))
    },
    onSelectNode: (nodeId) => {
      const { builderId, buttonId, keepType } = props
      dispatch(buttonActions.selectButtonNextStep(builderId, buttonId, { nodeId, keepType }))
    },
  }),
)(NextStepSelect)

ButtonNextStepSelectController.propTypes = {
  builderId: PropTypes.string,
  buttonId: PropTypes.string,
}

export default ButtonNextStepSelectController
